import { render } from "./Candidates2View.vue?vue&type=template&id=0dcce4e2"
import script from "./Candidates2View.vue?vue&type=script&lang=js"
export * from "./Candidates2View.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__